import { IConfigurations } from '@epicuro-next/platform/configuration';

export const SELLER_TOOLS_FEATURE_NAME = 'seller-tools';

export enum SellerRulesConfigurationKeys {
  BasketReminderEnabled = 'basket-reminder-enabled',
  BasketReminderPageConfig = 'basket-reminder-page-config',
  BudgetEnabled = 'budget-enabled',
  BudgetPageConfig = 'budget-page-config',
  BudgetPageReadOnlyMode = 'budget-page-readonly-mode',
}

export interface SellerToolsConfiguration
  extends IConfigurations<SellerRulesConfigurationKeys> {
  [SellerRulesConfigurationKeys.BasketReminderEnabled]: boolean;
  [SellerRulesConfigurationKeys.BasketReminderPageConfig]: string;
  [SellerRulesConfigurationKeys.BudgetEnabled]: boolean;
  [SellerRulesConfigurationKeys.BudgetPageConfig]: string;
  [SellerRulesConfigurationKeys.BudgetPageReadOnlyMode]: boolean;
}

export const sellerToolsConfigurationDefaultValues: SellerToolsConfiguration = {
  [SellerRulesConfigurationKeys.BasketReminderEnabled]: false,
  [SellerRulesConfigurationKeys.BasketReminderPageConfig]: JSON.stringify({}),
  [SellerRulesConfigurationKeys.BudgetEnabled]: false,
  [SellerRulesConfigurationKeys.BudgetPageConfig]: JSON.stringify({}),
  [SellerRulesConfigurationKeys.BudgetPageReadOnlyMode]: true,
};
